module.exports = __webpack_public_path__ + "img/CAL-UHF-Zubehörkoffer_transparent_Var1.a5357474.png";